(() => {
	if (window.__accountMenuBound) return;
	window.__accountMenuBound = true;

	const closeMenus = (eventTarget) => {
		document.querySelectorAll('.account-menu[open]').forEach((menu) => {
			if (!eventTarget || !menu.contains(eventTarget)) menu.removeAttribute('open');
		});
	};

	document.addEventListener('click', (event) => {
		const closeButton = event.target.closest('[data-account-menu-close]');
		if (closeButton) {
			event.preventDefault();
			closeButton.closest('.account-menu')?.removeAttribute('open');
			return;
		}
		closeMenus(event.target);
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') closeMenus();
	});

	const params = new URLSearchParams(location.search);
	if (params.get('account') !== 'open') return;

	params.delete('account');
	const search = params.toString();
	const strip = () => history.replaceState(null, '', location.pathname + (search ? `?${search}` : '') + location.hash);

	const menu = document.querySelector('.account-menu');
	if (menu) {
		menu.setAttribute('open', '');
		strip();
		return;
	}

	const tryOpen = (n = 40) => {
		const btn = document.querySelector('shopify-account')?.shadowRoot?.querySelector('[part~="signed-out-avatar"]');
		if (btn) {
			btn.click();
			strip();
			return;
		}
		if (n) setTimeout(() => tryOpen(n - 1), 100);
	};

	customElements.whenDefined('shopify-account').then(() => tryOpen());
})();
